import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation(['common', 'home']);

  return (
    <section className="relative w-full min-h-[500px] md:min-h-[650px] flex items-center overflow-hidden bg-background-50 pt-16 md:pt-20">
      {/* Left Content */}
      <div className="relative z-10 w-full lg:w-[55%] px-4 md:px-6 lg:pl-12 xl:pl-20 py-16 md:py-24">
        <div className="max-w-xl">
          {/* H1 */}
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl xl:text-6xl leading-tight text-foreground-900 mb-4">
            <span className="font-bold">{t('hero_h1_line1')}</span>
            <br />
            <span className="italic font-semibold text-primary-600">{t('hero_h1_line2')}</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xs md:text-sm font-sans text-foreground-500 mb-8 max-w-md leading-relaxed">
            {t('hero_subtitle')}
          </p>

          {/* Description */}
          <p className="text-sm md:text-base text-foreground-600 mb-10 max-w-lg leading-relaxed">
            {t('hero_desc')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 px-6 py-3 bg-foreground-900 text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('cta_main_site')}
              <span className="w-6 h-6 rounded-full border border-background-50/30 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 px-6 py-3 border-2 border-foreground-900 text-foreground-900 text-sm md:text-base font-medium rounded-full hover:bg-foreground-900 hover:text-background-50 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('cta_buy_now')}
              <span className="w-6 h-6 rounded-full border border-foreground-900/30 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* Right Image Area */}
      <div className="hidden lg:block absolute right-0 top-0 bottom-0 w-[45%]">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20airy%20workspace%20with%20MacBook%20on%20natural%20oak%20wooden%20desk%2C%20colorful%20sticky%20notes%20on%20cork%20board%20in%20background%2C%20ceramic%20vase%20with%20fresh%20eucalyptus%20branches%2C%20warm%20sunlight%20streaming%20through%20sheer%20curtains%2C%20Scandinavian%20minimalist%20interior%2C%20editorial%20photography%2C%20fresh%20and%20inviting%2C%20high%20detail&width=1600&height=900&seq=hero-desk-v3&orientation=landscape"
          alt="Hipobuy Spreadsheet workspace"
          title="Hipobuy Spreadsheet workspace setup"
          className="w-full h-full object-cover rounded-l-[40px]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/10 to-transparent rounded-l-[40px]"></div>
      </div>

      {/* Mobile image banner */}
      <div className="lg:hidden absolute bottom-0 left-0 right-0 h-[40%] opacity-25">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20airy%20workspace%20with%20MacBook%20on%20natural%20oak%20wooden%20desk%2C%20colorful%20sticky%20notes%20on%20cork%20board%20in%20background%2C%20ceramic%20vase%20with%20fresh%20eucalyptus%20branches%2C%20warm%20sunlight%20streaming%20through%20sheer%20curtains%2C%20Scandinavian%20minimalist%20interior%2C%20editorial%20photography%2C%20fresh%20and%20inviting%2C%20high%20detail&width=1600&height=900&seq=hero-desk-v3&orientation=landscape"
          alt="Hipobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}